// extracted by mini-css-extract-plugin
export default {"loading":"OrderPaneLoading_loading__glO5y"};